import React, { useState, useEffect, useCallback } from 'react';
import './HeroSlider.css';

import img4 from '../../assets/images/school/img4.png';
import img3 from '../../assets/images/school/img3.jpeg';
import visitImg from '../../assets/images/programs/visit/pic.png';
import hortiImg from '../../assets/images/programs/horticulture/pic3.png';
import img1 from '../../assets/images/school/img1.jpeg';
import showbouy from '../../assets/images/school/showbouy.jpg';
import awardsImg from '../../assets/images/school/awards.png';
import groupImg from '../../assets/images/school/group.jpeg';
import newsImg from '../../assets/images/news/news.jpeg';
import maizeImg from '../../assets/images/programs/training/maize.png';
import harvestImg from '../../assets/images/school/harvest.png';

const slides = [
    {
        id: 6,
        image: awardsImg,
        title: "",
        subtitle: "",
        bgColor: "#ffffff",
        textColor: "#ffffff",
        shapeType: 'none',
        position: 'left',
        btnText: "",
        btnLink: ""
    },
    {
        id: 8,
        image: harvestImg,
        title: "EMPOWERING SUSTAINABLE AGRICULTURE",
        subtitle: "Showbouys Foundation LBG provides tailored training in sustainable agriculture, environmental stewardship, and community resilience.",
        bgColor: "#ffffff",
        textColor: "#000000",
        shapeType: 'concentric',
        position: 'right',
        btnText: "ABOUT US",
        btnLink: "/about",
        imgPosition: "center center"
    },
    {
        id: 0,
        image: maizeImg,
        title: "Scientific Maize Cultivation.",
        subtitle: "Training students at Hemang SHS on best practices for fertilizer application and crop management.",
        bgColor: "#6FBF3A",
        textColor: "#ffffff",
        shapeType: 'curved',
        position: 'left',
        btnText: "Learn More",
        btnLink: "/activity/4",
        imgPosition: "top center"
    },
    {
        id: 1,
        image: img4,
        title: "Empowering Futures Through Education.",
        subtitle: "We believe every child deserves access to quality learning and a path to success.",
        bgColor: "#ffffff",
        textColor: "#6FBF3A",
        shapeType: 'curved',
        position: 'left',
        btnText: "Learn More",
        btnLink: "/about"
    },
    {
        id: 2,
        image: img3,
        title: "",
        subtitle: "",
        bgColor: "#ffffff",
        textColor: "#ffffff",
        shapeType: 'none',
        position: 'left',
        btnText: "",
        btnLink: ""
    },
    
    {
        id: 7,
        image: groupImg,
        title: "",
        subtitle: "",
        bgColor: "#ffffff",
        textColor: "#ffffff",
        shapeType: 'none',
        position: 'left',
        btnText: "",
        btnLink: "",
        imgPosition: "center center"
    },
    {
        id: 3,
        image: visitImg,
        title: "Collaborative Leadership.",
        subtitle: "Partnering with national leaders to drive systemic change in rural development.",
        bgColor: "#2F5FA8",
        textColor: "#ffffff",
        shapeType: 'slanted',
        position: 'right',
        btnText: "Join Us",
        btnLink: "/contact"
    },
    {
        id: 4,
        image: hortiImg,
        title: "Restoring Ecological Balance.",
        subtitle: "Dedicated to environmental conservation and climate-resilient community initiatives.",
        bgColor: "#6FBF3A",
        textColor: "#ffffff",
        shapeType: 'curved',
        position: 'left',
        btnText: "Support Us",
        btnLink: "/donate"
    }
];

const HeroSlider: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleNext = useCallback(() => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex((prev) => (prev + 1) % slides.length);
        setTimeout(() => setIsAnimating(false), 1000);
    }, [isAnimating]);

    const handlePrev = useCallback(() => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);
        setTimeout(() => setIsAnimating(false), 1000);
    }, [isAnimating]);

    const goToSlide = (index: number) => {
        if (isAnimating || index === currentIndex) return;
        setIsAnimating(true);
        setCurrentIndex(index);
        setTimeout(() => setIsAnimating(false), 1000);
    };

    useEffect(() => {
        const interval = setInterval(handleNext, 6000);
        return () => clearInterval(interval);
    }, [handleNext]);

    return (
        <div className="hero-slider">
            {slides.map((slide, index) => (
                <div
                    key={slide.id}
                    className={`hero-slide ${index === currentIndex ? 'active' : ''} hero-slide--${slide.position} hero-slide--shape-${slide.shapeType}`}
                    style={{ '--slide-bg': slide.bgColor } as React.CSSProperties}
                >
                    <div className="hero-slide__content">
                        <div className="hero-slide__text-area">
                            <div className="hero-slide__text-inner">
                                <h1 style={{ color: slide.shapeType === 'concentric' ? 'var(--color-primary-green)' : slide.textColor }}>{slide.title}</h1>
                                <p style={{ color: slide.textColor }}>{slide.subtitle}</p>
                                
                                   <a  href={slide.btnLink}
                                    className="hero-slide__btn"
                                    style={{
                                        backgroundColor: slide.textColor === '#ffffff' || slide.shapeType === 'concentric' || slide.id === 1
                                            ? 'var(--color-primary-green)'
                                            : 'var(--color-primary-blue)',
                                        color: '#ffffff'
                                    }}
                                >
                                    {slide.btnText}
                                </a>
                            </div>

                            {slide.shapeType !== 'none' && slide.shapeType !== 'concentric' && (
                                <div className={`hero-slide__shape hero-slide__shape--${slide.shapeType}`}>
                                    {slide.shapeType === 'curved' ? (
                                        <svg viewBox="0 0 500 800" preserveAspectRatio="none">
                                            <path d="M0,0 L0,800 L300,800 C450,600 450,200 300,0 Z" />
                                        </svg>
                                    ) : (
                                        <svg viewBox="0 0 500 800" preserveAspectRatio="none">
                                            <path d="M0,0 L0,800 L450,800 L250,0 Z" />
                                        </svg>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="hero-slide__image-area">
                            {slide.shapeType === 'concentric' ? (
                                <div className="hero-slide__concentric-wrapper">
                                    <div className="hero-slide__concentric-rings">
                                        <div className="ring ring-1"></div>
                                        <div className="ring ring-2"></div>
                                        <div className="ring ring-3"></div>
                                    </div>
                                    <img src={slide.image} alt={slide.title} className="hero-slide__concentric-image" />
                                </div>
                            ) : (
                                <>
                                    <img 
                                        src={slide.image} 
                                        alt={slide.title} 
                                        style={{ objectPosition: (slide as any).imgPosition || 'top center' }}
                                    />
                                    <div className="hero-slide__image-overlay"></div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            ))}

            <div className="hero-slider__nav">
                <button className="hero-slider__nav-btn hero-slider__nav-btn--prev" onClick={handlePrev}>
                    &lsaquo;
                </button>
                <button className="hero-slider__nav-btn hero-slider__nav-btn--next" onClick={handleNext}>
                    &rsaquo;
                </button>
            </div>

            <div className="hero-slider__dots">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        className={`hero-slider__dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default HeroSlider;